import React from 'react';
import Navbar from '../Nav';
import ContactUs from '../Parts/ContactUs';
import Footer from '../Footer';
function Homepage() {
  return (
    <>
      <Navbar />
     <ContactUs />
      <Footer />
    </>
  );
}

export default Homepage;